"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ENRICHERS = {
    _msid: function (SDK) { return SDK.Utils.getInstanceValue('metaSiteId'); },
    _appId: function (SDK) { return SDK.Utils.getInstanceValue('appDefId'); },
    _instanceId: function (SDK) { return SDK.Utils.getInstanceId(); },
    _siteOwnerId: function (SDK) { return SDK.Utils.getSiteOwnerId(); },
    _siteMemberId: function (SDK) { return SDK.Utils.getUid() || ''; },
    _visitorId: function (SDK) { return SDK.Utils.getInstanceValue('aid'); },
    _viewMode: function (SDK) { return SDK.Utils.getViewMode(); }
};
function getBiContext(SDK) {
    return Object.keys(ENRICHERS).reduce(function (res, field) {
        res[field] = ENRICHERS[field](SDK);
        return res;
    }, {});
}
exports.getBiContext = getBiContext;
//# sourceMappingURL=index.js.map